import { render, staticRenderFns } from "./FullsizeImage.vue?vue&type=template&id=deea3ce6"
import script from "./FullsizeImage.vue?vue&type=script&lang=js"
export * from "./FullsizeImage.vue?vue&type=script&lang=js"
import style0 from "./FullsizeImage.vue?vue&type=style&index=0&id=deea3ce6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default,Link: require('/vercel/path0/components/elements/Link.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
